import { render } from "./GlobalChat.vue?vue&type=template&id=79815664"
import script from "./GlobalChat.vue?vue&type=script&lang=js"
export * from "./GlobalChat.vue?vue&type=script&lang=js"

import "./GlobalChat.vue?vue&type=style&index=0&id=79815664&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__